/** Key of header where request origin is sent */
export const ATMTS_REQUEST_ORIGIN_HEADER_NAME = "X-Atmts-Request-Origin";

/** Value of request origin header */
export const ATMTS_REQUEST_ORIGIN_HEADER_VALUE = "app.automotus.io";

/** Key of header carrying the active account context UUID */
export const ACCOUNT_CONTEXT_ID_HEADER_NAME = "X-Account-Context-Id";
